module.exports = __webpack_public_path__ + "static/media/game-press-symbol-culture.16d43515.png";